import React from "react";
import styles from "../WalletConnector.module.css";

export default function Initializing({ wallet }) {
  return (
    <div className={styles.section}>
      <div className={styles.navHeader}>
        <button className={styles.backButton}>Back</button>
        <button className={styles.closeButton}>×</button>
      </div>

      <div className={styles.initializingStatus}>Initializing...</div>

      {/* Add the progress bar */}
      <div className={styles.initializingProgress}>
        <div className={styles.initializingProgressBar}></div>
      </div>

      <div className={styles.walletCard}>
        <div className={styles.walletIconLarge}>
          <img
            src={
              wallet?.logo ||
              "/img/metamask-69ce6b56bbc9953dfb4aecebdf88729b.png"
            }
            alt={wallet?.name || "Metamask"}
            className={styles.walletIcon}
          />
        </div>
        <div className={styles.walletDetails}>
          <div className={styles.walletTitle}>{wallet?.name || "Metamask"}</div>
          <div className={styles.walletDescription}>
            Easy-to-use browser extension.
          </div>
        </div>
      </div>
    </div>
  );
}
